import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {cdnResize} from '../services/utils';
//import {execBI} from '../services/bi-events-manager';
import {openEditorApp} from '../services/app-flow';
import {FormattedMessage} from 'react-intl';
//import {isOpenInEditorVisible} from '../services/app-type-detector';
import {openDeletePopupMessage} from '../services/wrapped-app-market-sdk';
import ALink from './ALink';


const handleOpenInEditor = (app, biPosition = 0) => {
  return ev => {
    ev.preventDefault();
    openEditorApp(app, biPosition);
  };
};

const handleDeleteApp = (app) => {
  return ev => {
    ev.preventDefault();
    openDeletePopupMessage({appDefinitionId: app.appDefinitionId});
  };
};

const handleUpgradeApp = () => {
  return ev => {
    ev.preventDefault();
    //openUpgradePopupMessage(app.appDefinitionId);
  };
};


export default class MyApp extends React.Component {

  render() {
    const app = this.props.app;
    //const isOpenAppLinkVisible = isOpenInEditorVisible(app);

    return (
      <div className="my-app">
        <img
          className="app-logo"
          width="60"
          height="60"
          src={cdnResize(app.roundIcon || app.appIcon, 60, 60)}
          alt={`${app.name} || WIX App Market`}
          />

        <h3 className={classNames('application-title')}>{app.name}</h3>

        <ALink to={`/${app.slug}/overview`}><FormattedMessage id="application.action.open"/></ALink>

        <a href="#" onClick={handleOpenInEditor(app, this.props.biPosition)}>Manage</a>

        <a href="#" onClick={handleDeleteApp(app, this.props.biPosition)}>Delete App</a>

        <a href="#" onClick={handleUpgradeApp(app, this.props.biPosition)}>Upgrade App</a>

        <br className="clear"/>
      </div>
    );
  }
}

MyApp.propTypes = {
  app: PropTypes.object.isRequired,
  biPosition: PropTypes.number
};



// WEBPACK FOOTER //
// ./components/My-app.js